import { mapState } from "vuex";
export const cardCouponIndexMixins = {
  computed: {
    cardCouponTopBarList() {
      let topbarList = [
          {
              name: "优惠券管理",
              isActive: false,
              path: "/cardCoupon",
              icon:require("@/assets/img/menuIcons/icon-cardCoupon.png")
          },
      ];
      topbarList.forEach(val => {
          if (val.path == this.$route.path) {
              val.isActive = true;
          }
          if (val.childrenPath) {
              if (~val.childrenPath.indexOf(this.$route.path)) {
                  val.isActive = true;
              }
          }
      });
      return topbarList;
    },
  },
}
